/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  catchError,
  exhaustMap,
  filter,
  Observable,
  switchMap,
  take,
  throwError
} from 'rxjs';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { SKIP_JWT_INTERCEPTOR } from '~core/constants/global.constants';
import { AuthenticationService } from '../services/authentication.service';

export function jwtInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const authFacade = inject(AuthFacade);
  const authService = inject(AuthenticationService);
  if (
    request.headers.get('Authorization') ||
    request.context.get(SKIP_JWT_INTERCEPTOR) === true
  ) {
    return next(request);
  }

  return authFacade.accessToken$.pipe(
    take(1),
    switchMap(accessToken => {
      if (accessToken) {
        authService.lastUsedToken = accessToken.id;
        return next(
          request.clone({
            setHeaders: {
              authorization: `Bearer ${accessToken.id.trim()}`
            }
          })
        );
      }
      return next(request);
    }),
    catchError(error => {
      if (error instanceof HttpErrorResponse && 401 === error.status) {
        return authFacade.refreshToken$.pipe(
          take(1),
          filter(Boolean),
          switchMap(() => authFacade.refreshAccessToken()),
          exhaustMap(() => authFacade.accessToken$.pipe(take(1))),
          switchMap(accessToken => {
            if (!!accessToken && accessToken.id !== authService.lastUsedToken) {
              return next(
                request.clone({
                  setHeaders: { authorization: `Bearer ${accessToken.id}` }
                })
              );
            } else {
              return throwError(() => error);
            }
          })
        );
      }

      return throwError(() => error);
    })
  );
}
